import { useOutletContext } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { RouteContextParams } from 'modules/expenses/lib/RouteContextParams'
import { isMyExpensesSection } from 'modules/expenses/lib/common'

import { Group, useGroup } from './useGroup'

interface UseGroupDetailReturn {
  group?: Group
  loading: boolean
}

interface UseGroupDetail {
  id: number
  includeAttachments?: boolean
}

export const useGroupDetail = ({
  id,
  includeAttachments,
}: UseGroupDetail): UseGroupDetailReturn => {
  const { section, inExpiredFreeTrial } = useOutletContext<RouteContextParams>()
  const { employee } = useCurrentSession()

  const { group, loading } = useGroup({
    id,
    includeAttachments,
    includeDrafts: section === 'personal',
    employeeId: isMyExpensesSection(section) ? employee?.id : undefined,
    skip: inExpiredFreeTrial,
  })

  return { group, loading }
}
